import { Meta, Story } from '@storybook/react';
import { YearStep, YearStepProps } from './YearStep';
export default {
	title: 'Calculators/TravelDeduction/Steps/YearStep',
	component: YearStep,
} as Meta;

const Template: Story<YearStepProps> = (args: YearStepProps) => <YearStep {...args} />;

export const Default: Story<YearStepProps> = Template.bind({});
Default.args = {
	intro: '<p> Her kan du beregne dit kørselsfradrag, hvis du kender afstanden i kilometer. Beregneren kan også finde fradraget for kørsel over betalingsbro, men ikke transport med færge og fly. </p><p> Hvis du vil finde din kørselsrute ud fra adresser, anbefaler vi, at du bruger <a href="https://www.tastselv.skat.dk/borger/link?appl=retforskudsopgoerelsen">kørselsberegneren i TastSelv.</a></p>',
};
